import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ResponseWrapper } from '@shared';
import { TipoZona } from '@shared/models';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_TIPO_ZONA = '/tipo-zona';

@Injectable({
  providedIn: 'root',
})
export class TipoZonaService {
  private readonly API_URL_TIPO_ZONA = API_URL + ENDPOINT_TIPO_ZONA;
  private http = inject(HttpClient);

  listarTipoZona(): Observable<TipoZona[]> {
    return this.http.get<ResponseWrapper<TipoZona[]>>(this.API_URL_TIPO_ZONA).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
